module.exports = __webpack_public_path__ + "be4fcd215c79ead1faa79ee9a6e89d67.png";